export const environment = {
  production: true
,

adresseUrl: 'http://34.125.11.74:',
  
serverFinanceAdresse:'http://34.125.11.74:4224'
,serverAdresse:'http://34.125.11.74:4200'
,erpAdresse:'http://34.125.11.74:4223'

,restApi: 'http://34.125.11.74:8080/prospect/webresources/'
,restApiERP: 'http://34.125.11.74:8080/back-napec2022/webresources/'
,restApiAncienERP: 'http://34.125.11.74:8080/back-napec2020/webresources/'
,restApiCRM: 'http://34.125.11.74:8080/crm-1/webresources/'
,serverNPAECAdresse:'http://34.125.11.74:8080/NAPEC2020/index.xhtml',
 


/*

  adresseUrl: 'http://localhost:',


serverFinanceAdresse:'http://localhost:4224'
,serverAdresse:'http://localhost:4200'
,erpAdresse:'http://localhost:4223'

,restApi: 'http://localhost:8083/prospect/webresources/'
,restApiERP: 'http://localhost:8083/back-napec2022/webresources/'
,restApiAncienERP: 'http://localhost:8083/back-napec2020/webresources/'
,restApiCRM: 'http://localhost:8083/crm-1/webresources/'
,serverNPAECAdresse:'http://localhost:8080/NAPEC2020/index.xhtml',
*/




  //,restApiOnline: 'http://192.168.92.200:8082/OnlinePortailm-1.0/webresources/'
 

 

  firebaseConfig : {
    apiKey: "AIzaSyDazVJijQvxOMT9bLMebhxsQWd-jbBLH0M",
    authDomain: "badgesnapec.firebaseapp.com",
    databaseURL: "https://badgesnapec.firebaseio.com",
    projectId: "badgesnapec",
    storageBucket: "badgesnapec.appspot.com",
    messagingSenderId: "204195867803",
    appId: "1:204195867803:web:518c58b19677c1dc89aa3e",
    measurementId: "G-LKLRK0F9JK"
  } 
}; 
/*
 
  serverFinanceAdresse:'http://localhost:4224'
  ,serverAdresse:'http://localhost:4200'
  ,erpAdresse:'http://localhost:4223'
  
  ,restApi: 'http://localhost:8083/prospect/webresources/'
  ,restApiERP: 'http://localhost:8083/back-napec2022/webresources/'
  ,restApiAncienERP: 'http://localhost:8083/back-napec2020/webresources/'
  ,restApiCRM: 'http://localhost:8083/crm-1/webresources/'
  ,serverNPAECAdresse:'http://localhost:8080/NAPEC2020/index.xhtml',









adresseUrl: 'http://34.125.11.74:',

serverFinanceAdresse:'http://34.125.11.74:4224'
,serverAdresse:'http://34.125.11.74:4200'
,erpAdresse:'http://34.125.11.74:4223'

,restApi: 'http://34.125.11.74:8080/prospect/webresources/'
,restApiERP: 'http://34.125.11.74:8080/back-napec2022/webresources/'
,restApiAncienERP: 'http://34.125.11.74:8080/back-napec2020/webresources/'
,restApiCRM: 'http://34.125.11.74:8080/crm-1/webresources/'
,serverNPAECAdresse:'http://34.125.11.74:8080/NAPEC2020/index.xhtml',









 serverFinanceAdresse:'http://192.168.92.200:4224'
  ,serverAdresse:'http://192.168.92.200:4200'
  ,erpAdresse:'http://192.168.92.200:4223'
  
  ,restApi: 'http://192.168.92.200:8082/prospect/webresources/'
  ,restApiERP: 'http://192.168.92.200:8082/back-napec2022/webresources/'
  
  ,restApiCRM: 'http://192.168.92.200:8082/crm-1/webresources/'
  ,serverNPAECAdresse:'http://192.168.92.200:8080/NAPEC2020/index.xhtml',


   serverFinanceAdresse:'http://localhost:4224'
  ,serverAdresse:'http://localhost:4200'
  ,erpAdresse:'http://localhost:4223'
  
  ,restApi: 'http://localhost:8083/prospect/webresources/'
  ,restApiERP: 'http://localhost:8083/back-napec2022/webresources/'
  
  ,restApiCRM: 'http://localhost:8083/crm-1/webresources/'
  ,serverNPAECAdresse:'http://localhost:8080/NAPEC2020/index.xhtml',


*/
